import { Box } from '@mui/material';

import { BreakingMarketCardSkeleton } from './BreakingMarketCardSkeleton';

export const BreakingMarketsListSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {Array.from({ length: 4 }).map((_, index) => (
        <BreakingMarketCardSkeleton key={`breaking-market-skeleton-${index}`} />
      ))}
    </Box>
  );
};

export default BreakingMarketsListSkeleton;
